import cn from 'classnames';

import { useFilters, useOverrides } from '../../store';
import type { Flag } from '../../types';
import css from './stats.module.scss';

interface Props {
    flags: Flag[];
}
export function Stats({ flags }: Props) {
    const intl = new Intl.NumberFormat('en-US', { minimumIntegerDigits: 2 });
    const { overrides, filter, toggleFilter } = useOverrides();
    const { category } = useFilters();

    const total = flags.filter(f => category === 'all' || f.category === category);

    return (
        <div className={css.row}>
            <button className={cn(css.group, { [css.active]: !filter })} onClick={() => toggleFilter(false)}>
                <p>Total</p>
                <span className={css.total}>{intl.format(total.length)}</span>
            </button>
            <button className={cn(css.group, { [css.active]: filter })} onClick={() => toggleFilter(true)}>
                <p>Overrides</p>
                <span className={css.overrides}>{total.filter(f => f.key in overrides).length}</span>
            </button>
        </div>
    );
}
